"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var BlurBackgroundFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_BlurBackgroundFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.875 2H3.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C0 3.52 0 4.08 0 5.2v.675L3.875 2ZM0 8.812 6.812 2H9.75L8.082 3.668 8 3.667a3.133 3.133 0 0 0-3.132 3.215l-4.86 4.86C0 11.478 0 11.17 0 10.8V8.812ZM5.128 9.559l.6-.6c.096.1.198.194.307.281-.321.085-.625.191-.907.319ZM3.142 11.545l-2.17 2.17c.039.024.079.046.12.067C1.52 14 2.08 14 3.2 14h.35a2.624 2.624 0 0 1-.409-2.455ZM12.488 13.95a2.61 2.61 0 0 1-.038.05h.35c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 12.48 16 11.92 16 10.8v-.362l-3.512 3.512ZM12.562 10.938a3.27 3.27 0 0 0-.551-.647 4.267 4.267 0 0 0-1.05-.691l5.037-5.037c.002.19.002.401.002.637v2.3l-3.438 3.438ZM15.213 2.41 11.12 6.504a3.125 3.125 0 0 0-.962-1.975L12.687 2h.113c1.12 0 1.68 0 2.108.218.108.055.21.12.306.192Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.133 6.8a2.133 2.133 0 1 1-4.266 0 2.133 2.133 0 0 1 4.266 0ZM4 12.4C4 11.075 5.6 10 8 10c1.478 0 2.653.408 3.338 1.03.426.39.662.861.662 1.37a1.6 1.6 0 0 1-1.6 1.6H5.6A1.6 1.6 0 0 1 4 12.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_BlurBackgroundFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = BlurBackgroundFill;
exports["default"] = _default;